import { Component, OnDestroy, Inject, OnInit } from '@angular/core';
import { SuiModal, ComponentModalConfig, ModalSize } from '@richardlt/ng2-semantic-ui';
import { DOCUMENT } from '@angular/common';
import { fields } from './field';
interface IFieldSelectionModalContext {
	question: string;
	title?: string;
}
@Component({
	selector: 'app-selection-method-modal',
	templateUrl: './field-selection-modal.component.html',
	styleUrls: [ './field-selection-modal.component.scss' ]
})
export class FieldSelectionModalComponent implements OnInit, OnDestroy {
	fields: Array<any> = fields;
	options = [ 'Active', 'Rejected' ];
	searchable: boolean = true;
	constructor(@Inject(DOCUMENT) private document, public modal: SuiModal<IFieldSelectionModalContext, void, void>) {}
	ngOnInit() {
		// this.document.body.classList.remove('panel');
	}
	// s
	ngOnDestroy(): void {
		// this.document.body.classList.add('panel');
	}
}

export class FieldSelectionModal extends ComponentModalConfig<IFieldSelectionModalContext, void, void> {
	constructor(title: string, question: string, size: ModalSize = ModalSize.Small) {
		super(FieldSelectionModalComponent, { title, question });

		this.isClosable = false;
		this.transitionDuration = 200;
		this.size = size;
		this.transition = 'slide left';
		this.isFullScreen = false;
		this.isInverted = false;
	}
}
